<template>
  <div class="w-100">
    <div class="row">
      <div class="col-3">
        <b-form-group
            :label="$t('reports.filter.date_from')"
            label-for="dateFrom"
        >
          <date-range-picker v-model="dateFrom"
                             :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                             style="width: 100%;"
                             :singleDatePicker="true"
                             :time-picker="false"
                             :ranges="false"
                             :autoApply="true"
                             :opens="'right'">
            <template v-slot:input="picker" style="min-width: 350px;">
              <CalendarPlaceholder :date="picker.startDate" placeholder="reports.filter.calendar_placeholder"></CalendarPlaceholder>
            </template>
          </date-range-picker>
        </b-form-group>
      </div>
      <div class="col-3">
        <b-form-group
            :label="$t('reports.filter.date_from')"
            label-for="dateFrom"
        >
          <date-range-picker v-model="dateTo"
                             :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                             style="width: 100%;"
                             :singleDatePicker="true"
                             :time-picker="false"
                             :ranges="false"
                             :autoApply="true"
                             :opens="'right'">
            <template v-slot:input="picker" style="min-width: 350px;">
              <CalendarPlaceholder :date="picker.startDate" placeholder="reports.filter.calendar_placeholder"></CalendarPlaceholder>
            </template>
          </date-range-picker>
        </b-form-group>
      </div>
      <div class="col-3 d-flex align-items-end mb-3">
        <b-button class="btn" variant="secondary" @click="clearFilters">{{ $t('reports.btn.clear') }}</b-button>
        <b-button class="btn ml-2" variant="primary" @click="getReport">{{ $t('reports.btn.apply') }}</b-button>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <div class="spinner-wrapper" v-if="!marketing">
          <b-spinner></b-spinner>
        </div>
      </div>
      <div v-if="marketing && marketing.QUIZ_COINS" class="col-6">
        <b-card
            no-body
            border-variant="secondary"
            :header="$t('title.report.marketing_quiz_coins')"
            header-bg-variant="primary"
            header-text-variant="white"
            align="left"
        >
          <table v-if="marketing" class="table table-striped mb-0">
            <tbody>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.marketing.played_2_player_games') }}</td>
              <td>{{ marketing.QUIZ_COINS.played2PlayerGames }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.marketing.played_3_player_games') }}</td>
              <td>{{ marketing.QUIZ_COINS.played3PlayerGames }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.marketing.played_4_player_games') }}</td>
              <td>{{ marketing.QUIZ_COINS.played4PlayerGames }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.marketing.played_quick_tournamens') }}</td>
              <td>{{ marketing.QUIZ_COINS.playedQuickTournamens }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.marketing.played_scheduled_tournamens') }}</td>
              <td>{{ marketing.QUIZ_COINS.playedScheduledTournamens }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.marketing.entry_fee_2_player_games') }}</td>
              <td>{{ marketing.QUIZ_COINS.entryFee2PlayerGames }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.marketing.entry_fee_3_player_games') }}</td>
              <td>{{ marketing.QUIZ_COINS.entryFee3PlayerGames }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.marketing.entry_fee_4_player_games') }}</td>
              <td>{{ marketing.QUIZ_COINS.entryFee4PlayerGames }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.marketing.entry_fee_quick_tournamens') }}</td>
              <td>{{ marketing.QUIZ_COINS.entryFeeQuickTournamens }}</td>
            </tr>
            <tr>
              <td class="font-weight-bolder">{{ $t('table.report.marketing.entry_fee_scheduled_tournamens') }}</td>
              <td>{{ marketing.QUIZ_COINS.entryFeeScheduledTournamens }}</td>
            </tr>
            </tbody>
          </table>
        </b-card>
      </div>
      <div v-if="marketing && marketing.FUN_COINS" class="col-6">
        <b-card
            no-body
            border-variant="secondary"
            :header="$t('title.report.marketing_fun_coins')"
            header-bg-variant="secondary"
            header-text-variant="white"
            align="left"
        >
          <table class="table table-striped mb-0">
            <tbody>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.marketing.played_2_player_games') }}</td>
                <td>{{ marketing.FUN_COINS.played2PlayerGames }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.marketing.played_3_player_games') }}</td>
                <td>{{ marketing.FUN_COINS.played3PlayerGames }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.marketing.played_4_player_games') }}</td>
                <td>{{ marketing.FUN_COINS.played4PlayerGames }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.marketing.played_quick_tournamens') }}</td>
                <td>{{ marketing.FUN_COINS.playedQuickTournamens }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.marketing.played_scheduled_tournamens') }}</td>
                <td>{{ marketing.FUN_COINS.playedScheduledTournamens }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.marketing.entry_fee_2_player_games') }}</td>
                <td>{{ marketing.FUN_COINS.entryFee2PlayerGames }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.marketing.entry_fee_3_player_games') }}</td>
                <td>{{ marketing.FUN_COINS.entryFee3PlayerGames }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.marketing.entry_fee_4_player_games') }}</td>
                <td>{{ marketing.FUN_COINS.entryFee4PlayerGames }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.marketing.entry_fee_quick_tournamens') }}</td>
                <td>{{ marketing.FUN_COINS.entryFeeQuickTournamens }}</td>
              </tr>
              <tr>
                <td class="font-weight-bolder">{{ $t('table.report.marketing.entry_fee_scheduled_tournamens') }}</td>
                <td>{{ marketing.FUN_COINS.entryFeeScheduledTournamens }}</td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import DateRangePicker from "../../../components/DateRangePicker/components/DateRangePicker";
import moment from "moment";
import CalendarPlaceholder from "./CalendarPlaceholder";

export default {
  components: {
    DateRangePicker,
    CalendarPlaceholder
  },
  data() {
    return {
      dateFrom: {
        startDate: null
      },
      dateTo: {
        startDate: null
      }
    }
  },
  computed: {
    ...mapState({
      marketing: (state) => state.reports.marketing,
    }),
  },
  mounted() {
    this.getReport();
  },
  beforeDestroy() {
    this.$store.commit('reports/setMarketing', null);
  },
  methods: {
    clearFilters() {
      this.dateFrom = { startDate: null };
      this.dateTo = { startDate: null };

      this.getReport();
    },
    getReport() {
      const date = {
        dateFrom: this.dateFrom.startDate ? moment(this.dateFrom.startDate).format('YYYY-MM-DD') : null,
        dateTo: this.dateTo.startDate ? moment(this.dateTo.startDate).format('YYYY-MM-DD') : null
      }

      this.$store.dispatch('reports/getMarketingReport', date);
    }
  }
}
</script>
